<div class="cf-dlg cid" [class.cid--page]="!isDialog">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>upload_file</mat-icon></div>
    <div class="cid-header-text">
      <h2 class="cf-dlg-title">Importar contactos</h2>
      <p class="cf-dlg-subtitle">Sube tus contactos a Handly con nuestra plantilla Excel</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="working" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="working">
    <app-loading-state [message]="workingMessage"></app-loading-state>
    <div class="cid-progress" *ngIf="progress > 0 && progress < 100">
      <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
      <span class="cid-progress__label">{{ progress }}%</span>
    </div>
  </ng-container>

  <ng-container *ngIf="!working && !dataReady">
    <div class="cf-dlg-body">
      <span class="cf-dlg-section__label">1. Descarga la plantilla</span>
      <p class="cid-hint">Complétala con tus contactos respetando las columnas.</p>
      <div class="cf-dlg-upload-zone">
        <button type="button" class="cf-dlg-upload-btn cid-tile" (click)="downloadTemplate()">
          <mat-icon>description</mat-icon>
          Plantilla vacía
        </button>
        <button type="button" class="cf-dlg-upload-btn cid-tile" (click)="downloadDemoTemplate()">
          <mat-icon>table_view</mat-icon>
          Plantilla con ejemplo
        </button>
      </div>

      <span class="cf-dlg-section__label cid-section">2. Sube el archivo completado</span>
      <label class="cf-dlg-upload-btn cid-tile cid-tile--wide" for="contact-import-file">
        <mat-icon>cloud_upload</mat-icon>
        Seleccionar archivo Excel (.xlsx)
      </label>
      <input id="contact-import-file" type="file" (change)="fileChange($event)" accept=".xlsx" hidden />
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
    </div>
  </ng-container>

  <ng-container *ngIf="!working && dataReady">
    <div class="cf-dlg-body">
      <div class="cf-dlg-upload-success cid-file">
        <mat-icon>check_circle</mat-icon>
        <span class="cid-file__name">{{ selectedFileName }}</span>
        <span class="cid-file__count">{{ dataSource.length }} {{ dataSource.length === 1 ? 'contacto' : 'contactos' }}</span>
      </div>

      <ng-container *ngIf="dataSource.length; else emptyTpl">
        <span class="cf-dlg-section__label cid-section">Vista previa</span>
        <p class="cid-hint">Revisa los datos antes de confirmar la importación.</p>
        <div class="cid-warning-summary" *ngIf="rowsWithWarnings > 0">
          <mat-icon>warning</mat-icon>
          <span>{{ rowsWithWarnings }} {{ rowsWithWarnings === 1 ? 'contacto tiene' : 'contactos tienen' }} datos fiscales incompletos o no válidos. Se importarán igualmente.</span>
        </div>
        <div class="cid-table-wrap">
          <table class="cid-table">
            <thead>
              <tr>
                <th>Avisos</th>
                <th *ngFor="let column of headerTable">{{ column.title }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dataSource; trackBy: trackByIndex" [class.cid-row--warning]="row.importWarnings?.length">
                <td class="cid-warnings">
                  <span *ngFor="let warning of row.importWarnings" class="cid-warnings__item">{{ warning }}</span>
                </td>
                <td *ngFor="let column of headerTable">{{ cellValue(column, row) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-template #emptyTpl>
        <div class="cid-empty">
          <mat-icon>info</mat-icon>
          <span>El archivo no contiene contactos. Revisa que hayas rellenado la plantilla.</span>
        </div>
      </ng-template>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="resetFile()">
        <mat-icon>swap_horiz</mat-icon> Cambiar archivo
      </button>
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" [disabled]="!dataSource.length" (click)="addContacts()">
        <mat-icon>group_add</mat-icon> Importar {{ dataSource.length }} {{ dataSource.length === 1 ? 'contacto' : 'contactos' }}
      </button>
    </div>
  </ng-container>
</div>
